/**
 * Format a cooldown date for display in the picker.
 * Output is deterministic across locales (avoids the impure
 * `toLocaleDateString` behaviour the lint rule guards against).
 *
 * Examples:
 *   "Monday, Jun 23"
 *   null  →  null
 *   bad input → null
 */
const WEEKDAYS = ["Sunday", "Monday", "Tuesday", "Wednesday", "Thursday", "Friday", "Saturday"];
const MONTHS = ["Jan", "Feb", "Mar", "Apr", "May", "Jun", "Jul", "Aug", "Sep", "Oct", "Nov", "Dec"];

export function formatCooldownDate(iso) {
    if (!iso) return null;
    const t = new Date(iso).getTime();
    if (!Number.isFinite(t)) return null;
    const d = new Date(t);
    return `${WEEKDAYS[d.getDay()]}, ${MONTHS[d.getMonth()]} ${d.getDate()}`;
}

/**
 * Whether a reselection cooldown is still active for the given ISO timestamp.
 * Pure-ish helper outside the React render path so the purity lint rule is
 * satisfied.
 */
export function isCooldownActive(iso) {
    if (!iso) return false;
    const t = new Date(iso).getTime();
    if (!Number.isFinite(t)) return false;
    return t > Date.now();
}
